import React, { useEffect } from "react";
import { X } from "lucide-react";

const inputCls = "w-full rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-[#C5A059] outline-none px-3 py-2.5 text-sm transition-colors";
const Label = ({ children, required }) => (
  <label className="block text-[10px] font-semibold uppercase tracking-wider text-slate-600 mb-1.5">{children}{required && " *"}</label>
);

export const FieldIn = ({ label, val, onChange, type = "text", tid, required, placeholder }) => (
  <div>
    <Label required={required}>{label}</Label>
    <input type={type} value={val ?? ""} required={required} placeholder={placeholder}
      onChange={e => onChange(e.target.value)} data-testid={tid} className={inputCls} />
  </div>
);

export const FieldSel = ({ label, val, onChange, opts, tid, placeholder }) => (
  <div>
    <Label>{label}</Label>
    <select value={val ?? ""} onChange={e => onChange(e.target.value)} data-testid={tid} className={inputCls}>
      {placeholder && <option value="">{placeholder}</option>}
      {opts.map(o => typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.v} value={o.v}>{o.l}</option>)}
    </select>
  </div>
);

export const FieldArea = ({ label, val, onChange, rows = 3, tid, placeholder }) => (
  <div>
    <Label>{label}</Label>
    <textarea rows={rows} value={val ?? ""} placeholder={placeholder}
      onChange={e => onChange(e.target.value)} data-testid={tid} className={inputCls} />
  </div>
);

export const Modal = ({ title, onClose, children, wide, testid }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid={testid}>
    <div className={`bg-white rounded-2xl w-full ${wide ? "max-w-4xl" : "max-w-2xl"} max-h-[90vh] overflow-y-auto shadow-2xl`}
      onClick={e => e.stopPropagation()}>
      <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center sticky top-0 bg-white z-10">
        <h3 className="font-heading font-medium text-lg text-[#0F2A4A]">{title}</h3>
        <button onClick={onClose} data-testid={`${testid}-close`} className="p-1 rounded-lg hover:bg-slate-100"><X className="w-5 h-5" /></button>
      </div>
      <div className="p-6">{children}</div>
    </div>
  </div>
  );
};

export const Badge = ({ cls, children, tid }) => (
  <span data-testid={tid} className={`text-[11px] px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${cls}`}>{children}</span>
);
